'use es6';

import { List, Record } from 'immutable';
import { RequestStatus } from '../constants/base';
import Variation from './Variation';
const DEFAULTS = {
  status: RequestStatus.UNINITIALIZED,
  variations: List()
};
export default class Variations extends Record(DEFAULTS) {
  static fromJS(data) {
    return new Variations({
      status: RequestStatus.SUCCEEDED,
      variations: List(data.objects).map(Variation.fromJS).sortBy(variation => variation.abStatus)
    });
  }
}